export default __webpack_public_path__ + "static/media/ifwebreaktheice - originals - dolamubadejo bdic 1.6f92caf8.png";